'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NOT_DELETED = exports.NOT_DELETED = 'NOT_DELETED';
var SOFT_DELETED = exports.SOFT_DELETED = 'SOFT_DELETED';
var HARD_DELETED = exports.HARD_DELETED = 'HARD_DELETED';